import React, {Component} from 'react';
import { connect } from 'react-redux';

import DatabaseService from 'services/DatabaseService.js';
import {initNavbarState} from 'actions/navbar.js';
import SurveyContainer from 'modules/surveys/SurveyContainer.js';


class SetGoalsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {stepno:0};
        this.close = this.close.bind(this);
        this.completed = this.completed.bind(this);
        this.surveys = DatabaseService.getSurveysCache();
    }

    componentWillMount() {
        if(!Boolean(this.surveys.personality && this.surveys.personality.id)) {
            this.props.history.push('/home');
        }
        this.props.dispatch(initNavbarState({enable:true, mode:'light', backButtonEnable:true}));
    }

    close() {
        this.props.history.push('/home');
    }

    completed() {
        var surveys = this.surveys || {};
        surveys.personality = null;
        DatabaseService.setSurveysCache(surveys)
        this.close();
    }

    render() {
        var key = 'setgoals';
        var closeIconOpts = {key:key, name:'chevron left'};
        return (
            <SurveyContainer key={key} 
                             surveyId={this.surveys.personality.id}
                             navMode='light' 
                             noCompleteScreen
                             onCompleted={this.completed}
                             onEmpty={this.completed}
                             onClose={this.close} 
                             closeIconOpts={closeIconOpts} />);
    }
}


   
export default connect()(SetGoalsContainer); 



// WEBPACK FOOTER //
// ./src/modules/categories/SetGoalsContainer.js